import { iBisViewComponent } from '@dohu/ibis-common';
import { Component, Input, ViewChild } from '@angular/core';
import { ProxyService } from '../../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { EditSpecializationFormSettingsService } from './edit-specialization-form-setings.service';

@Component({
	selector: 'app-specialization-form-settings',
	templateUrl: './specialization-form-settings.component.html'
})
export class SpecializationFormSettingsComponent extends iBisViewComponent {
	@Input() specializationId: any = null;
	@ViewChild('gridSpecializationFormSettings') declare grid: DxDataGridComponent;
	// public declare edit: EditSpecializationFormSettingsService;
	constructor(public proxy: ProxyService, public edit: EditSpecializationFormSettingsService) {
		super(edit, proxy.lg, proxy.iui, proxy.activatedRoute);
		this.key = '[MDS]SpecializationFormSettings';
	}

	onGridInit() {
		this.edit.specializationId = this.specializationId;
	}
}
